export const learnMoreButton = ({ isMobile }) => ({
  color: "primary",
  border: "none",
  cursor: "pointer",
  fontFamily: "body",
  fontWeight: "light",
  fontSize: isMobile ? "20px" : "30px",
  justifyContent: "center",
  lineHeight: "1",
  letterSpacing: "0.025em",
  whiteSpace: "nowrap",
  textDecoration: "underline",
});
